<template>
  <div>
    <div
      id="select-connect-modal"
      class="modal"
      tabindex="-1"
      aria-hidden="true"
      data-backdrop="static"
      v-show="props.openModalStatus"
    >
      <div class="modal-dialog">
        <div class="modal-content bg-theme-39">
          <a
            data-dismiss="modal"
            href="javascript:;"
            @click="cancelConnectModalForm"
            class="absolute right-4 top-3 text-gray-500"
          >
            <XIcon class="w-8 h-8 text-gray-500" />
          </a>
          <div class="modal-header">
            <h3 class="text-theme-1 font-semibold text-md">
              เลือกระบบที่ต้องการส่งข้อมูล
            </h3>
          </div>
          <div class="modal-body p-6">
            <div class="bg-white rounded-md p-4">
                <div class="flex-1">                  
                  <div class="space-y-2" v-show="infoData?.sol_code || allowedSystems?.length > 0" :key="`list-${renderKey}`">
                    <template v-if="filteredInfoToBeSelect.length > 0">
                      <div 
                        v-for="(info, index) in filteredInfoToBeSelect" 
                        :key="`${info.field}-${renderKey}-${index}`"
                        class="flex items-center"
                      >
                        <label
                          :for="`system-${info.field}-${renderKey}`"
                          class="form-label cursor-pointer inline-flex items-center"
                        >
                          <input
                            :id="`system-${info.field}-${renderKey}`"
                            type="checkbox"
                            :value="info.field"
                            v-model="selectedSystems"
                            class="form-check-input mr-2 align-middle"
                            style="border: 2px solid #555;"
                          />
                          <span class="align-middle">
                            {{ info.label }} ({{ info.field }})
                          </span>
                        </label>
                      </div>
                    </template>
                    <p v-else class="text-sm font-normal text-gray-500">
                      ไม่พบข้อมูล (sol_code: {{ infoData?.sol_code }})
                    </p>
                  </div>
                </div>
              <hr class="col-span-12 mt-4" />
              <!-- footer -->
              <div class="col-span-12 flex items-center mt-4 justify-end">
                <button
                  class="btn btn-secondary ml-2"
                  data-dismiss="modal"
                  @click="cancelConnectModalForm"
                >
                  ยกเลิก
                </button>
                <button v-show="selectedSystems.length > 0 && validate"
                  class="btn btn-primary ml-2"
                  data-dismiss="modal"
                  @click="handleSaveAndClose"
                >ส่งข้อมูล
                </button>
                 <button v-show="!validate"
                  class="btn btn-primary ml-2"
                  data-dismiss="modal"
                  @click="handleSaveAndClose"
                >
                  {{ selectedSystems.length > 0 ? 'บันทึกและส่งข้อมูล' : 'บันทึก' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, watch, nextTick } from "vue";
import { useStore } from "vuex";
import solutionList from "@/data/solution_list.json";
import OtherSystemList from "@/data/other_system_list.json";

const store = useStore();
const img_connect_logo = ref("");
const selectedSystems = ref([]);
const filteredInfoToBeSelect = ref([]);
const renderKey = ref(0);

const props = defineProps({
  infoData: Object,
  allowedSystems: Array,
  validate: Boolean,
  openModalStatus: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:openModalStatus', 'handleSaveModal']);
const infoData = computed(() => props.infoData);
const openModalStatus = computed(() => props.openModalStatus);

const updateFilteredInfo = () => {
  const currentSolCode = props.infoData?.sol_code;
    const currentSolution = solutionList.find(sol => sol.sol_code === currentSolCode);
  let rawAllowed = currentSolution?.sol_sys || [];
console.log(currentSolCode)
  if (!currentSolCode) {
    if(props.allowedSystems?.length > 0){
rawAllowed = props.allowedSystems;
    }else{
    filteredInfoToBeSelect.value = [];
    renderKey.value++;
    return;
    }
  }
console.log(rawAllowed)
  const allowedSet = new Set(
    rawAllowed.map(item => (typeof item === 'string' ? item : item?.field)).filter(Boolean)
  );

  const newFiltered = OtherSystemList.filter(info => {
    const isAllowed = allowedSet.has(info.field);
    return isAllowed;
  });
  filteredInfoToBeSelect.value = JSON.parse(JSON.stringify(newFiltered));
  renderKey.value++;
};

const cancelConnectModalForm = () => {
  selectedSystems.value = [];
  emit('update:openModalStatus', false);
};

const handleSaveAndClose = () => {
  emit('handleSaveModal', selectedSystems.value.length > 0 ? selectedSystems.value : ["not_sent"]);
  selectedSystems.value = [];
  emit('update:openModalStatus', false);
};

const generateLogo = async () => {
  img_connect_logo.value = `<img class="connection-tags" src="${require("@/assets/images/logo/CSG.png")}">`;
};

watch(() => props.openModalStatus, async (newValue, oldValue) => {
  
  if (newValue) {
    updateFilteredInfo();
    // await nextTick();
    await nextTick();
    cash("#select-connect-modal").modal("show");
  } else {
    cash("#select-connect-modal").modal("hide");
  }
}, { immediate: false });

watch(() => props.infoData, async (newInfoData, oldInfoData) => {
  selectedSystems.value = [];
  updateFilteredInfo();
  // await nextTick();
}, { deep: true, immediate: true });

onMounted(() => {
  generateLogo();
  updateFilteredInfo();
});

</script>

<style></style>